(function () {
  document.querySelectorAll('[data-sv-product-reviews-track]').forEach(function (track) {
    var cards = track.querySelectorAll('.sv-product-reviews__card');
    if (cards.length < 2) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    // Same independent hover/focus tracking as sv-announcement-bar.js — a
    // shopper can be touching (mobile) while also having tabbed a card's
    // content into focus, and leaving one must not resume auto-advance while
    // the other is still active.
    var hovering = false;
    var focused = false;
    var touching = false;
    var intervalId = null;
    var ADVANCE_MS = 3500;

    // Advances to the NEXT snap point rather than a continuous pixel scroll —
    // continuous scrollLeft nudges fight scroll-snap-type:mandatory, which
    // snaps straight back to the current card on every tick (confirmed live,
    // not assumed). Determined from the actual current scroll position each
    // time (not a separately-tracked counter) so a shopper's manual swipe
    // never gets overridden by a stale "expected" index.
    function nearestCardIndex() {
      var nearest = 0;
      var nearestDistance = Infinity;
      cards.forEach(function (card, i) {
        var distance = Math.abs(card.offsetLeft - track.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearest = i;
        }
      });
      return nearest;
    }

    function advance() {
      var next = (nearestCardIndex() + 1) % cards.length;
      track.scrollTo({ left: cards[next].offsetLeft, behavior: 'smooth' });
    }

    function start() {
      if (intervalId || hovering || focused || touching) return;
      intervalId = setInterval(advance, ADVANCE_MS);
    }

    function stop() {
      clearInterval(intervalId);
      intervalId = null;
    }

    track.addEventListener('mouseenter', function () {
      hovering = true;
      stop();
    });
    track.addEventListener('mouseleave', function () {
      hovering = false;
      start();
    });
    track.addEventListener('focusin', function () {
      focused = true;
      stop();
    });
    track.addEventListener('focusout', function () {
      focused = false;
      start();
    });
    track.addEventListener(
      'touchstart',
      function () {
        touching = true;
        stop();
      },
      { passive: true }
    );
    track.addEventListener(
      'touchend',
      function () {
        touching = false;
        start();
      },
      { passive: true }
    );

    start();
  });
})();
